export const ROUTES = {
    home: '/',
    gallery: '/gallery',
    animation: '/animation',
    about: '/about'
};